import React from 'react';
import './App.css';
import HelloWorld from './components/HelloWorld';

function App() {
  return (
    <div className="App">
      
        <HelloWorld />
       
      
    </div>
  );
}

export default App;
